export default {
  en: {
    signedDocument: 'Signed Document',
    download: 'Download',
    addSignedDocument: 'Add Signed Document',
    upload: 'Upload',
    success: 'Success',
    uploadSuccessMessage: 'Upload Signed Document Success'
  },
  th: {
    signedDocument: 'เอกสารที่ลงนาม',
    download: 'ดาวน์โหลด',
    addSignedDocument: 'เพิ่มเอกสารที่ลงนาม',
    upload: 'อัพโหลด',
    success: 'สำเร็จ',
    uploadSuccessMessage: 'อัพโหลดเอกสารที่ลงนามสำเร็จ'
  }
}
